import { api } from '../api/client';
import { User } from '../types';

export const login = async (email: string, password: string): Promise<User> => {
  return api.post<User>('/auth/login', { email, password });
};

export const logout = async (): Promise<void> => {
  await api.post('/auth/logout');
};

export const resetPassword = async (_email: string): Promise<void> => {
  throw new Error(
    'Password reset is managed by your administrator. Contact admin to reset your password.'
  );
};

export const changeOwnPassword = async (
  currentPassword: string,
  newPassword: string
): Promise<void> => {
  await api.post('/auth/change-password', { currentPassword, newPassword });
};

export const getCurrentUser = async (): Promise<User | null> => {
  try {
    return await api.get<User>('/auth/me');
  } catch {
    return null;
  }
};

export const createUser = async (
  email: string,
  password: string,
  displayName: string,
  role: 'admin' | 'store_manager'
): Promise<User> => {
  return api.post<User>('/auth/users', { email, password, displayName, role });
};
